import clsx from 'clsx';

/**
 * Wortmarken-Icon der App - ein isometrischer Container/Würfel, gezeichnet
 * statt als Unicode-Symbol. Kräftiger blauer Verlauf statt einer flachen
 * einfarbigen Kachel - dezenter Dark-Navy-zu-Blau-Gradient statt der
 * mehrfarbigen "AI-Gradients", aber mit sichtbarer Farbpräsenz statt eines
 * reinen Umriss-Icons. Wird sowohl in der Sidebar als auch auf der
 * Login-Seite verwendet, damit die Marke an beiden Stellen identisch aussieht.
 */
export function BrandMark({ className }: { className?: string }) {
  return (
    <span className={clsx('relative flex shrink-0 items-center justify-center rounded-md bg-brand-gradient shadow-card', className)}>
      <svg viewBox="0 0 32 32" className="relative h-1/2 w-1/2 text-white" fill="none">
        <path d="M4 10.5L16 4l12 6.5-12 6.5-12-6.5z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        <path d="M4 10.5v11L16 28l12-6.5v-11" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        <path d="M16 17v11" stroke="currentColor" strokeWidth="1.8" />
      </svg>
    </span>
  );
}
